export default __webpack_public_path__ + "static/pic9-047dd0ecd6ef61bc2b3b37564d0f31d4.jpg";